module.exports = __webpack_public_path__ + "img/questionnaire.51e1c9b7.svg";